import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Accesses'

export const AccessesEP : EndPointConfig[] =[
    new EndPointConfig()
    .setMethod('GET')
    .setController(controller)        
    .setActionName("GetUserAccesses"),

]


